module.exports = __webpack_public_path__ + "static/media/logo-wordmark-black.3f4f754e.png";